module.exports = __webpack_public_path__ + "static/media/vintus.b520a316.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/vintus.webp
// module id = 699
// module chunks = 0